var _rect, _g, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindthebesttutor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "#F0F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_40342)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -107,
    y: -3391,
    width: 1440,
    height: 8103,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -107,
    y: -3391,
    width: 1440,
    height: 8306,
    fill: "#F5F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -160,
    width: 1295,
    height: 1322,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_827_40342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1427 18.875H19.7619C18.4212 18.875 17.3237 19.9725 17.3237 21.3132V33.5036H19.7619V21.3132H44.1427V35.9418H36.8284V38.38H44.1427C45.4834 38.38 46.5809 37.2821 46.5809 35.9418V21.3132C46.5809 19.9725 45.4834 18.875 44.1427 18.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8568 26.1914C23.837 26.1914 22.1997 27.8283 22.1997 29.8485C22.1997 31.8688 23.837 33.5057 25.8568 33.5057C27.8771 33.5057 29.514 31.8688 29.514 29.8485C29.514 27.8283 27.8771 26.1914 25.8568 26.1914ZM25.8568 31.0678C25.1832 31.0678 24.6379 30.5226 24.6379 29.8485C24.6379 29.1745 25.1832 28.6296 25.8568 28.6296C26.5309 28.6296 27.0761 29.1745 27.0761 29.8485C27.0761 30.5226 26.5309 31.0678 25.8568 31.0678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5426 28.6289L31.0907 35.0816C30.6167 35.5548 29.6798 35.9432 29.0094 35.9432H22.1998C19.507 35.9432 17.3237 38.1265 17.3237 40.8193V45.6957H33.1712V38.467C33.1712 37.1204 33.7176 35.9011 34.5997 35.019L39.2666 30.3529L37.5426 28.6289ZM30.7334 43.2575H19.7619V40.8193C19.7619 39.4753 20.8547 38.3814 22.1998 38.3814H30.7334V43.2575Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -106.5,
    y: -3390.5,
    width: 1439,
    height: 8102,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -4486,
    y: -12522,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -107,
    y: -3391,
    width: 1440,
    height: 8103,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindthebesttutor);
export default __webpack_public_path__ + "static/media/find the best tutor.5269fca371d3d305c72599d319abceaf.svg";
export { ForwardRef as ReactComponent };